//配置API接口地址
import axios from './network'

//获取城市列表数据
/*export const getCityList=params=>{
  return axios.get(`../../static/city.json`,params);
}*/

//获取城市列表数据
export const getCityList=params=>{
  return axios.post(`/shebao/cityConfig/getViewCityConfig`,params);
}

//获取缴费类型信息列表
export const getPriceTypeList=params=>{
  return axios.post(`/shebao/cityConfig/getCityConfigByCityId`,params);
}

//获取确认参保信息详情价格
export const getPriceType=params=>{
  var headers ={'Content-Type': 'application/json;charset=utf-8'};
  return axios.post(`/shebao/socialInsurance/getPriceSum`,params, headers);
}

//去支付
export const gotoPay=params=>{
  var headers ={'Content-Type': 'application/json;charset=utf-8'};
  return axios.post(`/shebao/order/addUserOrder`,params, headers);
}

//支付详情
export const getPayDetail=params=>{
  return axios.post(`/shebao/order/getOrder`,params);
}

//二维码支付
export const getQrcodePay=params=>{
  return axios.post(`/shebao/order/payIsSuccess`,params);
}



// WEBPACK FOOTER //
// ./src/api/api.js